import {Arrow} from "../../../img";


export default function AxisLabel({img, label, vertical = false}) {
    return (
        <div className={`axis-label${vertical ? ' axis-label-vertical' : ''}`}>
            <div className={'axis-icon'}>
                {img}
            </div>
            <div className={'arrow-icon'}>
                <Arrow/>
            </div>
            <span>{label}</span>
        </div>
    )
}